var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreamlineIconTranslate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 8.25V.75m-6 7.5V.75m3 7.5V.75m-3 4.5h3M6 23.25v-7.5m3 7.5v-7.5m-3 4.5h3m3.75-4.5a1.5 1.5 0 0 0-1.5 1.5v4.5a1.5 1.5 0 0 0 3 0v-4.5a1.5 1.5 0 0 0-1.5-1.5Zm3.75 0v6a1.5 1.5 0 0 0 1.5 1.5m2.25 0v-6a1.5 1.5 0 0 1 3 0v6m-3-3h3M15.734 4.641A8.251 8.251 0 0 1 20.25 12M4.334 15A8.206 8.206 0 0 1 3 10.5",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m16.5 10.5 3.75 1.5 2.25-3.75M6.75 12.001 3 10.501l-2.25 3.75",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconTranslate);
export default __webpack_public_path__ + "static/media/streamline-icon-translate.7b9aca93.svg";
export { ForwardRef as ReactComponent };